module.exports = __webpack_public_path__ + "media/icons/salonowy-grey-b647791d.png";